export default [
  {
    path: "/bantuan-perkebunan/",
    component: () =>
      import("@/pages/bantuan-perkebunan/bantuan-perkebunan-list.vue"),
    meta: {
      title: "Daftar Bantuan Perkebunan",
      // requiredLevel: ["admin", "superadmin", "admin_provinsi"],
    },
  },
  {
    path: "/bantuan-perkebunan/create",
    component: () =>
      import("@/pages/bantuan-perkebunan/bantuan-perkebunan-form.vue"),
    meta: { title: "Tambah Bantuan Perkebunan" },
  },
  {
    path: "/bantuan-perkebunan/detail/:id",
    component: () =>
      import("@/pages/bantuan-perkebunan/bantuan-perkebunan-detail.vue"),
    meta: { title: "Detail Bantuan Perkebunan" },
  },
  {
    path: "/bantuan-perkebunan/update/:id",
    component: () =>
      import("@/pages/bantuan-perkebunan/bantuan-perkebunan-update.vue"),
    meta: { title: "Update Bantuan Perkebunan" },
  },
  {
    path: "/bantuan-perkebunan/import",
    component: () =>
      import("@/pages/bantuan-perkebunan/bantuan-perkebunan-import.vue"),
    meta: { title: "Import Bantuan Perkebunan" },
  },
];
